
import Vue from "vue"
import Component from "vue-class-component"
import {Prop} from "vue-property-decorator"

export interface Dimension {
  name: string
  icon: string
  value1: string
  value2: string
}

@Component
export default class MetricDimension extends Vue {
  @Prop({required: true})
  dimension: Dimension

  @Prop({required: true})
  name1: string

  @Prop({required: true})
  name2: string

  @Prop({required: true})
  color: string
}
